<i18n lang="yaml">
  ru:
    ActionSidebarBrandingTitle: "Надпись \"Made on Yourgood Widget\""
  en:
    ActionSidebarBrandingTitle: "Inscription \"Made on Yourgood Widget\""
</i18n>

<template>
  <PWAsideBodyItem>
    <template #header>
      <div :class="$style.actionSidebarBranding">
        <PWSwitcher v-model="computedValue" />
        <span
          :class="$style.actionSidebarBrandingLabel"
          @click="computedValue = !computedValue"
        >
          {{ $t('ActionSidebarBrandingTitle') }}
        </span>
      </div>
    </template>
  </PWAsideBodyItem>
</template>

<script>
/**
 * UI
 */
import PWAsideBodyItem from '@/components/_ui/Sidebars/PWAsideBodyItem.vue'
import PWSwitcher from '@/components/_ui/PWSwitcher.vue'

export default {
  components: {
    PWAsideBodyItem,
    PWSwitcher
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedValue: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    }
  }
}
</script>

<style module lang="scss">
.actionSidebarBranding {
  display: inline-flex;
  gap: 16px;
  align-items: center;
}

.actionSidebarBrandingLabel {
  user-select: none;
  cursor: pointer;
}
</style>
